import { render } from "./MandatesOverview.vue?vue&type=template&id=6f478cc7"
import script from "./MandatesOverview.vue?vue&type=script&lang=js"
export * from "./MandatesOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__